// Copyright (c) Microsoft. All rights reserved.

import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { ReactComponent as TypingBalls } from '../../../assets/typing-balls-light.svg';
import { abtisAccentColorValueString } from '../../../styles';

const useStyles = makeStyles({
    root: {
        contain: 'strict',
        height: '28px',
        overflowY: 'hidden',
        width: '28px',
    },
    image: {
        animationDuration: '2.3s',
        animationIterationCount: 'infinite',
        animationName: {
            from: { transform: 'translateY(0)' },
            // 28px Height * 68 Steps = 1904px
            to: { transform: 'translateY(-1904px)' },
        },
        animationTimingFunction: 'steps(68)',
        '> path:first-child': {
            fill: abtisAccentColorValueString,
        },
    },
});

export const TypingIndicator: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {/* <Image role="presentation" className={classes.image} src={typingBalls} /> */}
            <TypingBalls className={classes.image} role="presentation" />
        </div>
    );
};
